var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('Toolbar'),_c('v-main',{staticClass:"pa-0",staticStyle:{"background-color":"white"}},[_c('v-fade-transition',{attrs:{"mode":"out-in"}},[_c('router-view',{key:_vm.routeKey})],1)],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }